
export default function ServicesSection() {
  const services = [
    {
      icon: '/images/Personalized Coaching.png',
      title: 'Personalized Coaching',
      description: 'Tailored training programs designed for individual athlete needs and goals'
    },
    {
      icon: '/images/Coaching.png',
      title: 'Live Remote Coaching',
      description: 'Real-time coaching sessions from anywhere in the world'
    },
    {
      icon: '/images/Management System.png',
      title: 'Club7MS - Club Management System',
      description: 'Comprehensive club management and administration tools'
    },
    {
      icon: '/images/Daily Practice Task.png',
      title: 'Daily Practice Task Management',
      description: 'Organize and track daily training activities and progress'
    },
    {
      icon: '/images/Daily Fitness Management Tool.png',
      title: 'Daily Fitness Management Tool',
      description: 'Monitor and manage athlete fitness levels and conditioning'
    },
    {
      icon: '/images/Audio_video_annotation_tool_RaysEye.png',
      title: 'Audio Video Annotation Tool "RaysEye"',
      description: 'Advanced video analysis and annotation for performance improvement'
    },
    {
      icon: '/images/Structured.png',
      title: 'Structured Courses',
      description: 'Comprehensive training curricula for skill development'
    },
    {
      icon: '/images/and Invoicing.png',
      title: 'Payment Collection and Invoicing',
      description: 'Streamlined financial management for sports organizations'
    },
    {
      icon: '/images/Integrated Scoring.png',
      title: 'Integrated Scoring Application',
      description: 'Real-time scoring and statistics tracking during games'
    },
    {
      icon: '/images/User Access and Coach.png',
      title: 'User Access and Coach Schedule Management',
      description: 'Efficient scheduling and access control for training sessions'
    }
  ];

  return (
    <section id="services" className="section-wrap bg-gray-900">
      <div className="page-container">
        <div className="text-center section-heading-gap">
          <h2 className="section-title mb-6">
            Sync360-Sport training's much needed <span className="text-orange-500">tech-reinvention.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 section-grid-gap">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-black/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 text-center hover:border-orange-500 transition-all duration-300 transform hover:scale-105 cursor-pointer"
            >
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 flex items-center justify-center">
                  <img
                    src={service.icon}
                    alt={`${service.title} icon`}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
              </div>
              <h3 className="text-lg font-semibold mb-3 text-white group-hover:text-orange-500 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
